import { IProductOfferingPrice } from 'app/shared/model/product-offering-price.model';
import { TaxTariffType } from 'app/shared/model/enumerations/tax-tariff-type.model';
import { ProductType } from 'app/shared/model/enumerations/product-type.model';

export interface ITaxTariffTranche {
  id?: number;
  type?: keyof typeof TaxTariffType | null;
  productType?: keyof typeof ProductType | null;
  trancheLowerBound?: number | null;
  trancheUpperBound?: number | null;
  productOfferingPrices?: IProductOfferingPrice[] | null;
}

export const defaultValue: Readonly<ITaxTariffTranche> = {};
